import { useCallback, useEffect, useState } from 'react';

/* Единая загрузка данных: состояние загрузки, ошибка, повтор.
   Ошибку не проглатываем — пользователь должен видеть, что цифры не приехали. */
export function useApi(loader, deps = []) {
  const [state, setState] = useState({ data: null, loading: true, error: null });
  const [tick, setTick] = useState(0);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const run = useCallback(loader, deps);

  useEffect(() => {
    let alive = true;
    setState((s) => ({ ...s, loading: true, error: null }));
    run()
      .then((data) => alive && setState({ data, loading: false, error: null }))
      .catch((error) => alive && setState({ data: null, loading: false, error }));
    return () => { alive = false; };
  }, [run, tick]);

  return { ...state, reload: () => setTick((t) => t + 1) };
}
